import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });
export const createBankEntries = async bankEntriesToCreate => {
  const response = await requestFunnel.post('bank-entries', bankEntriesToCreate, getOptions());
  return response.data;
};
export const getUnassignedBankEntries = async (bankAccountId, from, to, entryType) => {
  const path = `bank-entries/unassigned?bankAccountId=${bankAccountId}&from=${from}&to=${to}&entryType=${entryType}`;
  const response = await requestFunnel.get(path, getOptions());
  return response.data;
};
export const searchReconciliatedBackEntries = async (bankAccountId, bankMovements) => {
  const path = `bank-entries/reconciliated?bankAccountId=${bankAccountId}`;
  const options = getOptions();
  const response = await requestFunnel.post(path, { bankMovements }, options);
  return response.data;
};
export const getBankAccounts = async () => {
  const response = await requestFunnel.get('bank-entries/bank-accounts', getOptions());
  return response.data;
};
export const setBankEntriesAsAccounted = async bankEntriesIds => {
  const response = await requestFunnel.patch('bank-entries', { bankEntriesIds }, getOptions());
  return response.data;
};
export const changeBankEntryDate = async (bankEntryId, date) => {
  const response = await requestFunnel.patch(`bank-entries/${bankEntryId}`, { date }, getOptions());
  return response.data;
};
